import React, { createContext, useState, useCallback, ReactNode } from 'react';
import Dialog from '@mui/material/Dialog';

interface ModalContextType {
    openModal: (modalContent: ReactNode) => void;
    closeModal: () => void;
}

export const ModalContext = createContext<ModalContextType>({
    openModal: () => {},
    closeModal: () => {}
});

interface ModalProviderProps {
    children: ReactNode;
}

export const ModalProvider: React.FC<ModalProviderProps> = ({ children }) => {
    const [isOpen, setIsOpen] = useState<boolean>(false);
    const [content, setContent] = useState<ReactNode>(null);

    const openModal = useCallback((modalContent: ReactNode) => {
        setContent(modalContent);
        setIsOpen(true);
    }, []);

    const closeModal = useCallback(() => {
        setIsOpen(false);
        setContent(null);
    }, []);

    return (
        <ModalContext.Provider value={{ openModal, closeModal }}>
            <Dialog open={isOpen} onClose={closeModal}>
                {content}
            </Dialog>
            {children}
        </ModalContext.Provider>
    );
};
